import { faFacebook, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "antd";
import { Link, useLocation } from "react-router-dom";

function Footer() {
  let {pathname} = useLocation();
  let isLandingPage = pathname === "/";

  return (
    <footer id="About" className={`${isLandingPage ? "bg-transparent" : "bg-gradient-to-bl from-[#0E1439] via-[#1C3CDB] to-[#0D173D]" }  mt-16 pt-16  px-16 sm:px-2 `}>
      <div className="flex flex-col gap-3 w-full justify-center sm:items-start items-center sm:max-w-none max-w-[480px] mx-auto">
        <p className="text-white font-josefin font-bold text-4xl sm:text-3xl">
          Download our App
        </p>
        <p className="text-[#01FFFF] text-base sm:text-sm font-Inter sm:text-left text-center">
          Stay connected to your son wherever you are! This app is designed for
          parents to easily track their children’s academic performance and
          grades.
        </p>
      </div>

      <div className="flex justify-between md:flex-col items-center gap-10 mt-10">
        <div className="flex items-center gap-5 ">
          <a
            className="w-36 h-auto"
            href="https://play.google.com/store/apps/details?id=com.parent.ourmatrix"
          >
            <img src="/assets/googleplay.png" alt="googleplay" />
          </a>
          <a
            className="w-36 h-auto"
            href="https://apps.apple.com/sa/app/our-matrix/id6743887804"
          >
            <img
              className="w-36 h-auto"
              src="/assets/appstore.png"
              alt="appstore"
            />
          </a>
        </div>
        <div className=" flex flex-col gap-6 items-center w-1/4 md:w-full md:items-center">
          <ul className="flex justify-center gap-6 items-center w-full  text-xl">
            <li className="bg-transparent w-12 h-12 rounded-full flex justify-center items-center hover:bg-bg duration-300  group cursor-pointer hover:scale-110">
              <a
                target="_blank"
                rel="noreferrer"
                className="text-bg/80 text-6xl  "
                href="https://www.facebook.com/MrMoamedSalama?mibextid=ZbWKwL
"
              >
                <FontAwesomeIcon
                  className="group-hover:scale-110 group-hover:text-blue duration-300"
                  icon={faFacebook}
                />{" "}
              </a>
            </li>
            <li className="bg-transparent w-12 h-12 rounded-full flex justify-center items-center hover:bg-bg duration-300  group cursor-pointer hover:scale-110">
              <a
                target="_blank"
                rel="noreferrer"
                className="text-bg/80 text-6xl  "
                href="https://youtube.com/@msmatrix?si=oqfpBpHgHQXv4Tuz"
              >
                <FontAwesomeIcon
                  className="group-hover:scale-110 group-hover:text-red-500 duration-300"
                  icon={faYoutube}
                />{" "}
              </a>
            </li>
            {/*   <li className="bg-transparent w-12 h-12 rounded-full flex justify-center items-center hover:bg-bg duration-300  group cursor-pointer hover:scale-110">
              <a
                target="_blank"
                rel="noreferrer"
                className="text-bg/80 text-2xl  "
                href="https://www.facebook.com/MrMoamedSalama?mibextid=ZbWKwL
"
              >
                <FontAwesomeIcon
                  className="group-hover:scale-110 group-hover:text-blue duration-300"
                  icon={faInstagram}
                />{" "}
              </a>
            </li>

            <li className="bg-transparent w-12 h-12 rounded-full flex justify-center items-center hover:bg-bg duration-300  group cursor-pointer hover:scale-110">
              <a
                target="_blank"
                rel="noreferrer"
                className="text-bg/80 text-2xl  "
                href="https://www.facebook.com/MrMoamedSalama?mibextid=ZbWKwL"
              >
                <FontAwesomeIcon
                  className="group-hover:scale-110 group-hover:text-blue duration-300"
                  icon={faYoutube}
                />{" "}
              </a>
            </li> */}
          </ul>
        </div>
      </div>

      <Row
        gutter={[16, 16]}
        className=" p-6 mt-8 text-white border-t-[4px] border-white "
      >
        <Col xs={24} md={6}>
          <div className="flex gap-3">
            <Link to="/privacy-policy" className="text-white">
              Privacy Policy
            </Link>
          </div>
        </Col>
        <Col xs={24} md={12}>
          <p className="text-center ">
            Created By{" "}
            <a
              className="font-bold "
              target="_blank"
              href="https://natlix.com/"
              rel="noreferrer"
            >
              Natlix{" "}
            </a>
            | © {new Date().getFullYear()} All Rights Reserved.
          </p>
        </Col>
      </Row>
    </footer>
  );
}

export default Footer;
